import { defineMessages } from 'react-intl';

export default defineMessages({
    searchPostcodePlaceholder: {
        id: 'Search for your postcode',
        defaultMessage: 'Search for your postcode'
    },
    noResultsHeading: {
        id: 'Oops. Your postcode is not valid',
        defaultMessage: 'Oops. Your postcode is not valid'
    },
    CrownDependencyPostcodeHeading: {
        id: 'You must be a UK resident to apply',
        defaultMessage: 'You must be a UK resident to apply'
    },
    noResultsBody: {
        id: 'Make sure you enter your full home postcode and click search. If you’re having trouble finding your address, please enter it manually',
        defaultMessage:
            'Make sure you enter your full home postcode and click search. If you’re having trouble finding your address, please enter it manually'
    },
    chooseCountry: {
        id: 'Choose your country',
        defaultMessage: 'Choose your country'
    },
    enterPostcode: {
        id: 'Enter your home postcode',
        defaultMessage: 'Enter your home postcode'
    },
    enterPostcodeSubtext: {
        id: 'We need your home address in order to run credit and identity checks',
        defaultMessage:
            'We need your home address in order to run credit and identity checks'
    },
    searchForAddressLink: {
        id: 'Search for my address',
        defaultMessage: 'Search for my address'
    }
});
